import JQuery from 'jquery'
window.$ = JQuery

require('../bootstrap');
require("./index");
require("./faq");
require("./service");
require("./chat");
require("./complaint");
require("./swiper");
require("./parking");
require("./pdf");
require("./jquery.rwdImageMaps");
require("./liveChat");

import { createApp } from "vue";
import HelloWorld from "./components/ExampleComponent.vue";
import SelectIcon from "./components/SelectIconComponent.vue";

const app = createApp({});

app.component("hello-world", HelloWorld);
app.component("select-icon", SelectIcon);

app.mount("#app");
